import { Button } from "@tblabs/truffle";


export class DangerButton extends Button
{
    constructor(label: string, onClick?: () => void)
    {
        super(label, onClick);
        this.Class("uk-button uk-button-danger")
            .Style("white-space: nowrap;");
    }
}
